export const assignWhisky = (navigate) => {
  navigate('/assign-whisky');
};